import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';
import { alertGridAreaActions } from './constants';
import { useSlotContext } from '../../utils/useSlotContext';

export const AlertActions = (props: PropsWithChildren) => {
    const { actionsGap, children } = useSlotContext(props, 'alert');

    return (
        <Stack
            direction="row"
            gap={actionsGap ?? 2}
            sx={{
                gridArea: alertGridAreaActions,
            }}
        >
            {children}
        </Stack>
    );
};
